<template>
  <section id="main-wrap" class="pure-g">
    <div id="main-col" class="pure-u-3-5">

      <h3>Your top-rated grapes</h3>

      <div id="home-grapes">
        <Grape v-for="grape in grapes" :grapeInstance="grape" :key="grape.id" />
      </div>

    </div>
  </section>

</template>

<script>
  import Grape from './Grape.vue'
  import firebase from 'firebase'
  import db from './firebaseInit'

  export default {
    name: 'top-rated',
    data () {
      return {
        currentUserID: null,
        grapeIDs: [],
        grapes: [],
        username: '',
        loading: true,
        search: ''
      }
    },
    created () {
      this.fetchData()
    },
    watch: {
      '$route': 'fetchData'
    },
    methods: {
      fetchData () {
        let vm = this
        firebase.auth().onAuthStateChanged(function (user) {
          vm.currentUserID = user.uid
          vm.getRated()
        })
      },
      getRated: function () {
        let vm = this
        vm.grapeIDs = []
        vm.grapes = []
        db.collection('grapeRatings').where('userID', '==', vm.currentUserID).where('rating', '==', '5').orderBy('createdTimestamp', 'desc').get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var data = doc.data()
            vm.grapeIDs.push(data.grapeID)
          })
          vm.grapeIDs.forEach(grapeID => {
            db.collection('grapes').where('id', '==', grapeID).get().then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                var grapeData = doc.data()
                grapeData.docID = doc.id
                if (!vm.checkGrapePresent(vm.grapes, grapeData.id, true)) {
                  vm.grapes.push(grapeData)
                } else {
                  console.log('top rated grapes has duplicate')
                }
              })
            })
          })
        })
      },
      checkGrapePresent: function (inArr, grapeID, exists) {
        for (var i = 0; i < inArr.length; i++) {
          if (inArr[i].id === grapeID) {
            return (exists === true) ? true : inArr[i]
          }
        }
      }
    },
    components: {
      Grape
    }
  };
</script>

<style scoped>
  #main-wrap {
    background: #f9f9f9;
    min-height: 100vh;
  }
  #add-grape-button {
    width: 100%;
    margin: 0 auto 20px;
    background: #36a731;
    color: #fff;
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    padding: 15px 20px;
  }
  #search-grapes {
    width: 60%;
    margin: 0 auto 20px;
    line-height: 30px;
    padding-left: 5px;
    padding-right: 5px;
    box-sizing: border-box;
  }
  #home-grapes {
    margin-top: 40px;
  }
  .aux-col {
    box-sizing: border-box;
    padding: 30px 50px;
    text-align: left;
  }
  .aux-col > h5 {
    text-transform: uppercase;
    border-bottom: 1px solid #36a731;
    margin: 0 0 20px;
    padding-bottom: 8px;
    display: inline-block;
  }
</style>


// WEBPACK FOOTER //
// src/components/TopRated.vue